import { Box, Title } from "@mantine/core";

interface SiteTasksBoxProps {
  title?: string;
  children: React.ReactNode;
}

function SiteTasksBox({ title, children }: SiteTasksBoxProps) {
  return (
    <Box
      bd="2px solid var(--mantine-color-grey-light)"
      bdrs="md"
      bg="white"
      p="sm"
    >
      {title && <Title order={3}>{title}</Title>}
      {children}
    </Box>
  );
}

export { SiteTasksBox };
